var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrDo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79986 21.48C9.98652 21.6666 10.2132 21.7866 10.4532 21.8666C10.6265 21.9466 10.8132 22 11.0132 22C11.2132 22 11.3999 21.9466 11.5599 21.8666C11.7999 21.7866 12.0265 21.6666 12.2132 21.48L19.2132 14.4666C19.7332 13.9466 19.7332 13.1066 19.2132 12.5866C18.6932 12.0666 17.8532 12.0666 17.3332 12.5866L12.3599 17.5866V2.01333C12.3599 1.27999 11.7732 0.679993 11.0265 0.679993C10.2799 0.679993 9.69319 1.27999 9.69319 2.01333V17.5866L4.70652 12.5999C4.18652 12.0799 3.34652 12.0799 2.82652 12.5999C2.30652 13.1199 2.30652 13.96 2.82652 14.48L9.82652 21.4933L9.79986 21.48Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 22C19.5999 22 18.9999 22.6 18.9999 23.3333C18.9999 24.2133 18.1999 24.68 17.4532 24.68H4.51992C3.75992 24.68 2.99992 24.2133 2.99992 23.3333C2.99992 22.6 2.39992 22 1.66659 22C0.933252 22 0.333252 22.6 0.333252 23.3333C0.333252 25.5867 2.17325 27.3467 4.51992 27.3467H17.4532C19.8132 27.3467 21.6666 25.5867 21.6666 23.3333C21.6666 22.6 21.0666 22 20.3333 22Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrDo);
export default __webpack_public_path__ + "static/media/arrDo.e3749bf968ac4b6fa017c29a66538dcb.svg";
export { ForwardRef as ReactComponent };